import {gql} from "@apollo/client";

const DELETE_PERMISSION = gql`
    mutation deletePermission($idPermission: ID!) {
        deletePermission(id: $idPermission)
    }
`;

export default DELETE_PERMISSION;
